var map = {
	"./Screenshot 2024-08-17 at 11.31.31.png": 14,
	"./Screenshot 2024-08-17 at 11.31.39.png": 15,
	"./Screenshot 2024-08-17 at 11.31.47.png": 16,
	"./Screenshot 2024-08-17 at 11.31.54.png": 17,
	"./Screenshot 2024-08-18 at 11.54.24.png": 18,
	"./Screenshot 2024-08-18 at 11.54.46.png": 19,
	"./Screenshot 2024-08-18 at 11.54.58.png": 20,
	"./Screenshot 2024-08-18 at 11.55.11.png": 21,
	"./Screenshot 2024-08-18 at 11.55.28.png": 22,
	"./Screenshot 2024-08-18 at 11.55.40.png": 23,
	"./Screenshot 2024-08-18 at 11.55.55.png": 24,
	"./Screenshot 2024-08-18 at 11.56.06.png": 25
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13;